export const mobile_title_big = '1.5rem';
export const mobile_title = '1.1rem'; //titles
export const mobile_big = '1rem'; //text
export const mobile_normal = '0.9rem'; //inputs, label, buttons
export const mobile_medium = '0.8rem'; //texts
export const mobile_small = '0.7rem'; // terms and conditions, license
